import { ContentChildren, Directive, ElementRef, QueryList } from '@angular/core'
import { SelectOptionDirective } from '@app-domains/ui/components/select/option/select-option.directive'

// eslint-disable-next-line @angular-eslint/directive-selector -- native optgroup selector
@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector -- native optgroup selector
    selector: 'select > optgroup',
    standalone: false,
})
export class SelectOptGroupDirective {
    @ContentChildren(SelectOptionDirective)
    public options: QueryList<SelectOptionDirective>

    constructor(
        public el: ElementRef<HTMLOptionElement>,
    ) {
    }
}
